import { useEffect } from 'react';
import { pushEscapeLayer } from '../../../ui/escape-stack';

/**
 * While a Hierarchy menu is open, Escape belongs to the menu. The V2 account lens registers an
 * escape-stack layer that navigates back, and Glaze's Dropdown does not mark its Escape as
 * handled, so without this layer one keypress would close the menu AND leave the account. The
 * guard is a topmost no-op layer held only while `open`; the Dropdown still closes itself.
 */
export function useMenuEscapeGuard(open: boolean): void {
  useEffect(() => {
    if (!open) return undefined;
    return pushEscapeLayer(() => {});
  }, [open]);
}
